{
  "accountRole": "Kontorolle",
  "accountRoles": {"administrator": "Administration", "member": "Mitglied"},
  "avatar": {
    "cancel": "Abbrechen",
    "change": "Bild ändern",
    "choose": "Bild auswählen",
    "cropArea": "Der sichtbare Teil Ihres Bildes",
    "cropHint": "Ziehen Sie das Bild oder nutzen Sie die Pfeiltasten, um den sichtbaren Teil zu wählen.",
    "hint": "Erscheint überall, wo Ihr Name steht. Ohne Bild steht dort ein Muster, das für Sie erzeugt wurde.",
    "loading": "Bild wird geöffnet …",
    "remove": "Bild entfernen",
    "save": "Bild speichern",
    "title": "Bild",
    "unreadable": "Diese Datei ist kein Bild, das Ihr Browser öffnen kann.",
    "zoom": "Zoom"
  },
  "connections": {
    "callback": {
      "denied": "Nichts wurde verbunden: Die Freigabe wurde abgebrochen oder kam nicht vollständig zurück.",
      "title": "Verbinden",
      "working": "Die Verbindung wird abgeschlossen …"
    },
    "connect": "Mit {{provider}} verbinden",
    "connectAgain": "Erneut mit {{provider}} verbinden",
    "connectedAs": "Verbunden als {{login}}.",
    "disconnect": "Trennen",
    "disconnectHint": "Trennen wirkt sofort: Quellen, die Sie darüber importiert haben, werden nicht mehr abgerufen. Was DMW schon kopiert hat, bleibt.",
    "disconnected": {
      "failed": "In DMW getrennt. {{provider}} hat es nicht bestätigt; ziehen Sie DMWs App in Ihren {{provider}}-Einstellungen unter „Applications“ zurück.",
      "revoked": "Getrennt. Auch {{provider}} hat DMWs Zugriff zurückgezogen.",
      "unsupported": "In DMW getrennt. Ziehen Sie DMWs Zugriff auch in Ihren {{provider}}-Einstellungen zurück."
    },
    "install": "DMWs App in Repositorys installieren",
    "installHint": "DMW liest nur die Repositorys, in denen Sie seine App installieren, und liest sie nur.",
    "needsReconnect": "{{provider}} nimmt diese Verbindung nicht mehr an.",
    "notConnected": "Nicht verbunden.",
    "off": {
      "not_configured": "Auf diesem Server nicht eingerichtet. Fragen Sie Ihre Administration.",
      "secret_unreadable": "Nicht eingerichtet: Der Server kann die Geheimnisse der Verbindung nicht lesen. Fragen Sie Ihre Administration.",
      "vault_off": "Nicht eingerichtet: Dem Server fehlt der Schlüssel, um Tokens verschlüsselt aufzubewahren. Fragen Sie Ihre Administration."
    },
    "title": "Verbindungen"
  },
  "displayName": "Name",
  "email": "E-Mail",
  "helpView": {
    "newTab": "In einem neuen Tab",
    "opens": "Hilfe öffnet sich",
    "samePage": "Anstelle der Seite"
  },
  "logout": "Abmelden",
  "memories": {
    "personalPolicy": "Agenten dürfen Erinnerungen speichern",
    "policies": {
      "confirm": "Erst mich fragen",
      "keep": "Sofort behalten",
      "off": "Dürfen nicht speichern"
    }
  },
  "pages": {
    "account": "Konto",
    "connectors": "Diesen PC verbinden",
    "label": "Profilseiten",
    "memories": "Meine Erinnerungen",
    "preferences": "Persönliche Einstellungen"
  },
  "personalPermissions": "Welche Werkzeuge auf Ihrem PC laufen dürfen und was Agenten dort dürfen, legen Sie auf diesem PC fest: im Berechtigungsprofil Ihres DMW Connectors und wenn ein Durchlauf Sie fragt. Siehe",
  "signUpEmails": {
    "hint": "Eine E-Mail für jede neue Registrierung, wenn diese Installation E-Mails versendet.",
    "label": "E-Mails zu Registrierungen",
    "off": "Nicht senden",
    "on": "Senden"
  },
  "threadView": {
    "autoSettle": "Inaktive Durchläufe archivieren nach",
    "autoSettleChoices": {
      "off": "Nie",
      "one_day": "1 Tag",
      "one_month": "1 Monat",
      "one_week": "1 Woche",
      "three_days": "3 Tagen"
    },
    "condensed": "Kompakt",
    "detailed": "Ausführlich",
    "hidden": "Ausgeblendet",
    "toolCalls": "Werkzeugaufrufe in Durchläufen"
  },
  "title": "Profil",
  "workflowView": {
    "density": "Prozessschema-Karten",
    "densityHint": "Die Vorgabe für eine Prozessschema-Seite; ihre Werkzeugleiste ändert nur diese Seite.",
    "layout": "Richtung des Prozessschema-Graphen"
  }
}
